import {ChannelPartner, ChannelPartnerGroup, ChannelPartnerGroupType} from '../model/channel-partner.model';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Injectable} from '@angular/core';

@Injectable()
export class ChannelPartnerService {
    private httpClient: HttpClient;
    private configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    async getPartnerDetails(channelPartnerId: string): Promise<ChannelPartner> {
        const url = `${this.configService.baseUrl()}partner?channel-partner-id=${channelPartnerId}`;
        const responseJson = await this.httpClient.get<any>(url).toPromise();
        return ChannelPartner.from(responseJson);
    }

    async notifyAboutEligibilityOption(loanId: string): Promise<void> {
        const url = `${this.configService.baseUrl()}partner/sendLoanOptions`;
        return await this.httpClient.post<void>(url, {loanApplicationId: loanId}).toPromise();
    }

    public async getPartnerByIds(partnerIds: string[]): Promise<ChannelPartner[]> {
        const url = `${this.configService.baseUrl()}partners/by-ids`;
        const channelPartners = await this.httpClient.post<any>(url, partnerIds).toPromise();
        return channelPartners.map(channelPartner => ChannelPartner.from(channelPartner));
    }

    public async getPartnerByName(partnerName: string): Promise<ChannelPartner> {
        const encodedPartnerName = encodeURIComponent(partnerName);
        const url = `${this.configService.baseUrl()}partner?channel-partner-name=${encodedPartnerName}`;
        const channelPartner = await this.httpClient.get<any>(url).toPromise();
        return ChannelPartner.from(channelPartner);
    }

    public async getPartnerByNames(partnerNames: string[]): Promise<ChannelPartner[]> {
        const url = `${this.configService.baseUrl()}partners/by-names`;
        const channelPartners = await this.httpClient.post<any>(url, partnerNames).toPromise();
        return channelPartners.map(channelPartner => ChannelPartner.from(channelPartner));
    }

    public async getChannelPartnerGroupByType(type: ChannelPartnerGroupType): Promise<ChannelPartnerGroup> {
        const url = `${this.configService.baseUrl()}partner-group?type=${type}`;
        return await this.httpClient.get<any>(url).toPromise();
    }

    public async belongsToPartnerGroupByType(partner: ChannelPartner, partnerGroupType: ChannelPartnerGroupType): Promise<boolean> {
        if (partner && partner.partnerGroupIds && partner.partnerGroupIds.length > 0) {
            const partnerGroup = await this.getChannelPartnerGroupByType(partnerGroupType);
            const partnerGroupId = partner.partnerGroupIds.find(groupId => groupId === partnerGroup._id);
            return partnerGroupId !== undefined && partnerGroupId !== null;
        }
        return false;
    }

    public async belongsToPartnerGroup(partner: ChannelPartner, partnerGroup: ChannelPartnerGroup): Promise<boolean> {
        if (partner && partner.partnerGroupIds && partner.partnerGroupIds.length > 0) {
            const partnerGroupId = partner.partnerGroupIds.find(groupId => groupId === partnerGroup._id);
            return partnerGroupId !== undefined && partnerGroupId !== null;
        }
        return false;
    }
}
